import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

// Define the initial state for the Program Dashboard onboarding
export interface ProgramOnboardingState {
  programName: string
  programOwnerName: string
  programOwnerEmail: string
  description: string
  appDAccount: string
  appResponseTimeQuery: string
  availabilityQuery: string
  infrastructureCost: string
  service: string
  serviceOffering: string
  configurationItem: string
  assignmentGroup: string
  costTag: string
  workItemType: string
  uatState: string
  id: string
  editMode: boolean
  ownerDepartment: string
  hourToStoryPointRatio: number
  // Add more program-specific fields as needed
}

export interface OldProgramReference {
  oldProductId: string | undefined
  linkAction: string
  oldConfigurationItemName?: string | undefined
}

export const initialState: ProgramOnboardingState = {
  programName: '',
  programOwnerName: '',
  programOwnerEmail: '',
  description: '',
  appDAccount: '',
  ownerDepartment: '',
  appResponseTimeQuery: '',
  availabilityQuery: '',
  infrastructureCost: '',
  service: '',
  serviceOffering: '',
  configurationItem: '',
  assignmentGroup: '',
  costTag: '',
  workItemType: '',
  uatState: '',
  id: '',
  editMode: false,
  hourToStoryPointRatio: 8,
}

const programOnboardingSlice = createSlice({
  name: 'programOnboarding',
  initialState,
  reducers: {
    setProgramOnboarding: (state, action: PayloadAction<Partial<ProgramOnboardingState>>) => {
      return {...state, ...action.payload}
    },
  },
})

interface OldProgramReferenceState {
  oldProductId: string | undefined
  linkAction: string
  oldConfigurationItemName: string | undefined
}

const initialOldProgramReferenceState: OldProgramReferenceState = {
  oldProductId: undefined,
  linkAction: '',
  oldConfigurationItemName: undefined,
}

const oldProgramReferenceSlice = createSlice({
  name: 'oldProgramReference',
  initialState: initialOldProgramReferenceState,
  reducers: {
    setOldProgramReference: (state, action: PayloadAction<Partial<OldProgramReference>>) => {
      return {...state, ...action.payload}
    },
  },
})

export const {setProgramOnboarding} = programOnboardingSlice.actions
export const {setOldProgramReference} = oldProgramReferenceSlice.actions

export const oldProgramReferenceReducer = oldProgramReferenceSlice.reducer
export const programOnboardingReducer = programOnboardingSlice.reducer
